var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndNodeFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2322 2.74805H8.56908C6.10099 2.74805 4.86695 2.74805 4.10022 3.48028C3.3335 4.21251 3.3335 5.39102 3.3335 7.74805L3.42199 12.748H13.2322C15.0848 12.748 16.0111 12.748 16.4041 12.2693C16.5128 12.1369 16.5925 11.9848 16.6382 11.8222C16.8034 11.2347 16.2477 10.527 15.1361 9.11171C14.6737 8.52292 14.4426 8.22854 14.4013 7.89396C14.3894 7.79702 14.3894 7.69907 14.4013 7.60213C14.4426 7.26755 14.6737 6.97317 15.1361 6.38441C16.2477 4.96906 16.8034 4.26138 16.6382 3.67386C16.5925 3.51131 16.5128 3.35923 16.4041 3.22677C16.0111 2.74805 15.0848 2.74805 13.2322 2.74805Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 17.7484V6.91504",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndNodeFlag);
export default __webpack_public_path__ + "static/media/EndNodeFlag.5c876c30e52ac4cce2b60f12cb0c96ec.svg";
export { ForwardRef as ReactComponent };